// ----------------------------------------------------------------------

const account = {
  displayName: 'Admin',
  email: 'admin@asktek.com',
  photoURL: `${process.env.PUBLIC_URL}/assets/images/avatars/user.png`,
};

export default account;
